import React from "react";

import {
  FiRefreshCcw,
  FiSearch,
} from "react-icons/fi";

const CustomerFilters = ({
  filters,
  setFilters,
  loading,
  onSearch,
  onReset,
}) => {
  const handleChange = (event) => {
    const { name, value } = event.target;

    setFilters((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      onSearch();
    }
  };

  return (
    <div className="customer-filter-section">
      <div className="customer-filter-card">
        <div className="customer-filter-grid">
          <div className="customer-filter-search-field">
            <FiSearch />

            <input
              type="text"
              name="search"
              value={filters.search}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              placeholder="Search customer name, mobile, email or company"
              disabled={loading}
            />
          </div>

          <select
            name="status"
            value={filters.status}
            onChange={handleChange}
            disabled={loading}
          >
            <option value="">
              All Status
            </option>

            <option value="Active">
              Active
            </option>

            <option value="Inactive">
              Inactive
            </option>

            <option value="Blocked">
              Blocked
            </option>
          </select>

          <button
            type="button"
            className="customer-filter-search-button"
            onClick={onSearch}
            disabled={loading}
          >
            <FiSearch />

            {loading
              ? "Searching..."
              : "Search"}
          </button>

          <button
            type="button"
            className="customer-filter-reset-button"
            onClick={onReset}
            disabled={loading}
          >
            <FiRefreshCcw />
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerFilters;